


























import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { getTastChainType } from '@/known_blockchains'
import { DEFAULT_NETWORK_NAME } from '@/store/modules/network/network'

@Component({})
export default class TransactionResult extends Vue {
    @Prop() item!: any

    select() {
        this.$router.push({
            path: `/tx/${this.item.id}`,
            query: { network: DEFAULT_NETWORK_NAME },
        })
        this.$emit('select')
    }

    get chainColor() {
        return getTastChainType(this.item.chainID)!.color
    }

    get chainDarkColor() {
        return getTastChainType(this.item.chainID)!.darkColor
    }

    get chainName() {
        return getTastChainType(this.item.chainID)!.name
    }
}
